import { appInfo } from "../common/data/appinfo";
export default [
  // results
  {
    path: "/wjcK3lQRjrd6",
    children: [
      {
        path: "e9463989ab92fca871d2a45e",
        name: "results",
        meta: {
          title:
            appInfo?.type === "codsms" ? "Result" : "Result",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/result/index.vue"),
      },
      {
        path: "e9463989ab92fca871d2a45eawq",
        name: "arm-results",
        meta: {
          title: "Result",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/result/index-arm.vue"),
      },
      {
        path: "wjcK3lQRjrd6oIcQNJ5OZubA",
        name: "termly-result",
        meta: {
          title:
            appInfo?.type === "codsms" ? "Termly Result" : "Semester Result",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/result/result.vue"),
      },
      // {
      //   path: "wjcK3lQRjrd6oIcQNJ5OZubA",
      //   name: "termly-result",
      //   meta: {
      //     title:
      //       appInfo?.type === "codsms" ? "Termly Result" : "Semester Result",
      //     authRequired: true,
      //     acc: null,
      //   },
      //   component: () => import("@/views/result/templates/template-1.vue"),
      // },
      // {
      //   path: "oIcQNJ5OZubAoqhdaq6xD7lt",
      //   name: "sessional-result",
      //   meta: {
      //     title: "Sessional Result",
      //     authRequired: true,
      //     acc: null,
      //   },
      //   component: () => import("@/views/result/sessional.vue"),
      // },
      {
        path: "oIcQNJ5OZubAoqhdaq6xD7lt",
        name: "midterm-result",
        meta: {
          title: "Midterm Result",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/result/templates/template-1.vue"),
      },

      // sessional result
      {
        path: "sessional-result",
        name: "arm-sessional-results",
        meta: {
          title: "Sessional Result",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/result/index-arm-sessional.vue"),
      },
      {
        path: "sessional-result-e",
        name: "sessional-results",
        meta: {
          title: "Sessional Result",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/result/index-sessional.vue"),
      },
      {
        path: "190a-f245a-qe341-li989-QNJ5OZubA",
        name: "sessional-result-template",
        meta: {
          title: "Print Sessional Result",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/result/sessional-arm-result.vue"),
      },
    ],
  },



  // comments
  {
    path: "/MBWSNBLUdfKNMBWSNBLUdfKN",
    children: [
      {
        path: "efFgstyER7LUB01xp/:level?",
        name: "entermyResultComment",
        meta: {
          title: "Update Comment",
          authRequired: true,
          acc: ["y80701"],
        },
        component: () => import("@/views/score-comment/update.vue"),
      },
    ],
  },
  {
    path: "/MBWSNBLUdfKNMBWSNBLUdfKNd",
    children: [
      {
        path: "efFgstyER7LUB01xp/:lvl?",
        name: "enterHeadComment",
        meta: {
          title: "Update Comment",
          authRequired: true,
          acc: ["y1332838"],
        },
        component: () => import("@/views/score-comment/updateHead.vue"),
      },
    ],
  },

  // Traits
  {
    path: "/MBWSNBLUdfKNMBWSNBLUdfKaN",
    children: [
      {
        path: "efFgstyER7LUBldw/:lvl?",
        name: "enterResultTrait",
        meta: {
          title: "Update Trait",
          authRequired: true,
          acc: ["y68529"],
        },
        component: () => import("../views/score-traits/update.vue"),
      },
      {
        path: "efFgstyER7LUBldWDQWDWQDw/:lvl?",
        name: "viewResultTrait",
        meta: {
          title: "View Trait",
          authRequired: true,
          acc: ["y93347"],
        },
        component: () => import("../views/score-traits/view.vue"),
      },
    ],
  },
];
